// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._29I4J_jwWns9fSiHUKlk9o{height:.96rem !important;font-size:.37333rem !important;font-family:'Roboto-Bold'}\n", "",{"version":3,"sources":["webpack://src/client/pages/shoppingcart/pages/unpaid/fragments/pay-button/style.module.scss"],"names":[],"mappings":"AAEA,yBACI,wBAA6B,CAC7B,8BAAgC,CAChC,yBAA0B","sourcesContent":["@import '../../../../../../base.scss';\n\n.CheckoutButton{\n    height: actual(36) !important;\n    font-size: actual(14) !important;\n    font-family: 'Roboto-Bold';\n}\n\n.PaypalButton{\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CheckoutButton": "_29I4J_jwWns9fSiHUKlk9o"
};
module.exports = ___CSS_LOADER_EXPORT___;
